import type { CoachClient } from '../screens/CoachScreen';
import type { CoachExchange, CoachSource, CoachTopic, CoachWorkspace } from '../types/coach';
import { coachTopicKey } from './coachTopic';

/** How a platform reaches the coach: fetch on the web, IPC on the Mac. */
export interface CoachTransport {
  load(topic: string): Promise<CoachWorkspace>;
  ask(question: string, requestId: string, topic: string): Promise<CoachExchange>;
  /** Saved notes and check-ins, which belong to the main chat only. */
  main: Pick<CoachClient, 'saveMemory' | 'changeMemory' | 'savePreferences' | 'prepareCheckins'>;
}

/** The chat about one topic. */
export function coachClientFor(
  topic: CoachTopic,
  transport: CoachTransport,
  openSource?: (source: CoachSource) => void
): CoachClient {
  const key = coachTopicKey(topic);
  return {
    load: () => transport.load(key),
    ask: (question, requestId) => transport.ask(question, requestId, key),
    openSource,
    ...(topic.kind === 'main' ? transport.main : {}),
  };
}
